import React from "react";
import GoogleLogo from "../../assets/google_logo.webp";
import ReadMoreArea from "@foxeian/react-read-more";

export default function ReviewsComponentNew({ data }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-4 px-4 xs:px-6  md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl  xl:mx-auto 2xl:px-0">
      {data?.reviews?.slice(0, 27)?.map((item, index) => {
        return (
          <div
            key={index}
            className=" flex flex-col items-start gap-3 bg-gradient-to-tl from-bhagwa to-orange-400 to-60% pt-4 pb-4"
          >
            <div className="flex flex-row items-center">
              <img
                className="h-[50px] w-fit object-contain pr-5 pl-5 md:pl-3 md:pr-3 md:h-[50px]"
                src={GoogleLogo}
                alt="google logo"
              />
              <div className="flex text-yellow-400 text-xl">
                {"★".repeat(5)}
              </div>
            </div>
            {/* <h2 className="text-left pl-5 pr-5 pt-3 tracking-wider font-[lato] font-normal sm:text-lg md:pl-3 md:pr-3 md:text-lg">
                            {review}
                      </h2> */}
            <h3 className="text-white text-left pl-5 pr-5 pt-3 font-[lato] font-normal sm:text-lg md:pl-3 md:pr-3 md:text-lg">
              <ReadMoreArea lettersLimit={200}>
                {item?.review_text}{" "}
              </ReadMoreArea>
            </h3>
            <span className="text-left italic text-white font-[optima-lt-pro] font-normal text-base pl-5 pr-5 md:pl-3 md-pr-3">
              - {item?.customer_name}
            </span>
          </div>
        );
      })}
    </div>
  );
}
